/* dcl-shoe-bonus-note.js  (rev 10)
 * 2026-11-02 (evening): eligibility now lives only in snippets/dcl-gift-card-note.
 *   This file never draws a note on its own; it only upgrades the server note.
 *   Clearance (no-discount, marked down) and open box pairs earn no card.
 * 2026-11-02: the quiet line is now server-rendered by snippets/dcl-gift-card-note
 *   (Liquid, product.dcl.json) so it is in the raw HTML Google reviews. This
 *   file keeps that node and only upgrades it to the full state on engagement.
 * Dialed Cycling Lab — surfaces the bonus gift card on Lake shoe pages.
 *
 * Two states, deliberately:
 *
 *   QUIET  — renders on every eligible page load. One muted line near the
 *            cart form. Required by Google Merchant Center: a gift-card
 *            promotion must be stated on the product landing page, and a
 *            reviewer loading a cold page has to be able to see it. Without
 *            this the promotion gets disapproved.
 *
 *   FULL   — replaces the quiet line once the shopper engages with the Lake
 *            offer. Centred, black mark, amount in red. This is the
 *            confirmation, not the pitch.
 *
 * The gating conditions mirror the Shopify Flow workflow exactly: Lake vendor,
 * tagged Shoes, not tagged no-discount. theme.liquid decides that part.
 *
 * Both states state the rule rather than a total, because the page does not
 * reliably know the chosen quantity at load. The cart line does the arithmetic.
 * One card per qualifying pair, no cap.
 */
(function () {
  'use strict';

  if (window.__dclShoeNote) return;
  window.__dclShoeNote = true;
  if (!window.DCL_SHOE_BONUS_NOTE) return;

  var QUIET_LEAD = 'Includes a ';
  var QUIET_AMOUNT = '$20';
  var QUIET_TAIL = ' Dialed gift card for every pair, emailed once your order is placed.';

  var FULL_LEAD = 'Includes a ';
  var FULL_AMOUNT = '$20';
  var FULL_TAIL = ' Dialed gift card for every pair, emailed once your order is placed.';

  var TERMS_HREF = '/pages/shoe-gift-card-terms';
  var TERMS_LABEL = 'Terms';

  var APPLIED = 'dcl_lake_offer_applied';
  var SAVED = 'dcl_lake_offer_saved';

  var ANCHORS = [
    '#MainContent form[action*="/cart/add"]',
    '#MainContent .product-form'
  ];

  function read(key, session) {
    try { return (session ? sessionStorage : localStorage).getItem(key); }
    catch (e) { return null; }
  }

  function hasEngaged() {
    var a = read(APPLIED, true);
    return a === 'done' || a === 'pending' || a === 'lapsed' || !!read(SAVED);
  }

  function anchor() {
    for (var i = 0; i < ANCHORS.length; i++) {
      var el = document.querySelector(ANCHORS[i]);
      if (el) return el;
    }
    return null;
  }

  function icon(size) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    ['M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z',
     'M12 8l0 13',
     'M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7',
     'M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5'
    ].forEach(function (d) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }

  function styles() {
    if (document.getElementById('dcl-sbn-css')) return;
    var s = document.createElement('style');
    s.id = 'dcl-sbn-css';
    s.textContent = [
      '.dcl-sbn{width:100%;box-sizing:border-box;font-family:inherit;',
      'opacity:0;transition:opacity .3s ease,transform .3s ease}',
      '.dcl-sbn.is-open{opacity:1;transform:none}',
      '.dcl-sbn__amt{color:#e42e0f!important}',
      '.dcl-sbn__terms{color:inherit;text-decoration:underline;',
      'text-underline-offset:2px;white-space:nowrap}',
      '.dcl-sbn--quiet{display:flex;align-items:center;gap:9px;',
      'margin:0 0 .9rem 0;font-size:.875rem;line-height:1.45;opacity:0}',
      '.dcl-sbn--quiet.is-open{opacity:.72}',
      '.dcl-sbn--quiet svg{flex-shrink:0}',
      '.dcl-sbn--full{display:flex;flex-direction:column;align-items:center;',
      'gap:10px;margin:-.5rem 0 1rem 0;padding:1rem .75rem;text-align:center;',
      'font-size:.9375rem;line-height:1.45;transform:translateY(4px)}',
      '.dcl-sbn__mark{display:flex;align-items:center;justify-content:center;',
      'flex-shrink:0;width:44px;height:44px;border-radius:50%;',
      'background:#1a1a1a;color:#fff!important}',
      '.dcl-sbn--full .dcl-sbn__text{display:block;max-width:34ch;font-weight:700}',
      '@media (max-width:749px){.dcl-sbn--full{padding:.9rem .5rem}',
      '.dcl-sbn__mark{width:38px;height:38px}',
      '.dcl-sbn--quiet{font-size:.8125rem}}',
      '@media (prefers-reduced-motion:reduce){.dcl-sbn{transition:none}}'
    ].join('');
    document.head.appendChild(s);
  }

  function textNode(lead, amount, tail) {
    var txt = document.createElement('span');
    txt.className = 'dcl-sbn__text';
    txt.appendChild(document.createTextNode(lead));
    var amt = document.createElement('span');
    amt.className = 'dcl-sbn__amt';
    amt.textContent = amount;
    txt.appendChild(amt);
    txt.appendChild(document.createTextNode(tail + ' '));
    var terms = document.createElement('a');
    terms.className = 'dcl-sbn__terms';
    terms.href = TERMS_HREF;
    terms.textContent = TERMS_LABEL;
    txt.appendChild(terms);
    return txt;
  }

  function build(full) {
    var note = document.createElement('div');
    note.className = 'dcl-sbn ' + (full ? 'dcl-sbn--full' : 'dcl-sbn--quiet');
    note.setAttribute('role', 'status');
    if (full) {
      var mark = document.createElement('span');
      mark.className = 'dcl-sbn__mark';
      mark.appendChild(icon(22));
      note.appendChild(mark);
      note.appendChild(textNode(FULL_LEAD, FULL_AMOUNT, FULL_TAIL));
    } else {
      note.appendChild(icon(17));
      note.appendChild(textNode(QUIET_LEAD, QUIET_AMOUNT, QUIET_TAIL));
    }
    return note;
  }

  function render(full) {
    var existing = document.querySelector('.dcl-sbn');
    if (existing && existing.classList.contains('dcl-sbn--full')) return true;
    var target = anchor();
    if (!target || !target.parentNode) return false;

    styles();
    var note = build(full);
    if (existing) existing.parentNode.replaceChild(note, existing);
    else target.parentNode.insertBefore(note, target);
    requestAnimationFrame(function () { note.classList.add('is-open'); });
    return true;
  }

  // Saving the offer does not reload the page, so watch for the offer module
  // dropping its recall row into the DOM and upgrade the line in place.
  // Unlocking the discount does reload; the storage check on boot covers that.
  function watch() {
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function () {
      if (!hasEngaged()) return;
      if (render(true)) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 300000);
  }

  function boot() {
    // No server-rendered note means the pair is not eligible. Do nothing.
    if (!document.querySelector('.dcl-sbn')) return;
    if (hasEngaged()) {
      if (render(true)) return;
    } else if (!document.querySelector('.dcl-sbn')) {
      render(false);
    }
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
